/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:22
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').
    controller('WebSiteServiceCtrl',["$log","$scope","$anchorScroll","$rootScope","$routeParams","$location","ServiceData","$timeout",
        function($log,$scope,$anchorScroll,$rootScope,$routeParams,$location,ServiceData,$timeout)
        {
            $scope.currentServiceId =  parseInt($routeParams.serviceId);

            $scope.$watch('ad.dataLoaded', function(newValue, oldValue)
            {
                if (newValue)// && !$scope.ad.view.currentServiceView)
                {
                    var service = ServiceData.getById( $scope.currentServiceId);
                    if (service && service.isVisibleOnWebSite)
                    {
                        $scope.ad.msgErrorService = "";
                        $scope.setCurrentServiceView($scope.ad.view.categoryRootView.getServiceView(service),false);
                    }
                    else
                    {
                        $scope.ad.msgErrorService = "Nous sommes désolés mais cette prestation n'existe plus ou n'est plus réservable.";
                    }
                    $timeout(function() {
                        if(window.FB) {
                            window.FB.XFBML.parse();
                        }
                    },300);
                }
            });

        }
    ]);


// WEBPACK FOOTER //
// ./js/controllers/customerSite/WebSiteServiceCtrl.js